import styled from 'vue3-styled-components';

export const VirtualAccountContainer = styled.div`
  display: flex;
  gap: 20px;
  height: 95%;
  padding: 10px;
  max-height: 800px;
  overflow: hidden;
`;

export const FormSection = styled.div`
  flex: 0.4;
  background: white;
  border-radius: 12px;
  padding: 5px 15px 15px 15px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  overflow-y: auto;

  /* 스크롤바 스타일링 */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
    margin: 4px 0;
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #cbd5e1, #94a3b8);
    border-radius: 10px;
    border: 2px solid #f1f5f9;
    transition: all 0.2s ease;
    
    &:hover {
      background: linear-gradient(135deg, #94a3b8, #64748b);
      transform: scale(1.05);
    }
    
    &:active {
      background: linear-gradient(135deg, #64748b, #475569);
    }
  }
  
  &::-webkit-scrollbar-corner {
    background: #f1f5f9;
  }

  /* 폼 컨테이너 */
  form {
    height: 100%;
  }
`;

export const NoticeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 10px;
  margin-bottom: 20px;
  font-size: 15px;
`;

export const HistorySection = styled.div`
  flex: 0.8;
  border-radius: 12px;
  padding: 0 15px 15px 15px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  max-height: 100%;
  overflow-y: auto;

  /* 스크롤바 스타일링 */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ffc971;
    border-radius: 3px;
  }
`;

export const Title = styled.h2`
  font-size: 20px;
  color: #cc5803;
  margin-bottom: 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  /* 아이콘 정렬을 위한 스타일 */
  svg {
    display: flex;
    align-items: center;
    margin-top: 1px;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const Label = styled.label`
  min-width: 140px;
  text-align: left;
  flex-shrink: 0;
  display: block;
  color: #495057;
  font-weight: 500;
`;

export const Input = styled.input`
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
  max-width: 400px;

  &:focus {
    outline: none;
    border-color: #4dabf7;
    box-shadow: 0 0 0 2px rgba(77,171,247,0.2);
  }
`;

export const Select = styled.select`
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  max-width: 400px;

  &:focus {
    outline: none;
    border-color: #4dabf7;
  }
`;

export const TextArea = styled.textarea`
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 14px;
  min-height: 70px;
  resize: vertical;
  max-width: 400px;

  &:focus {
    outline: none;
    border-color: #4dabf7;
    box-shadow: 0 0 0 2px rgba(77,171,247,0.2);
  }
`;

export const Button = styled.button`
  background: #fb8b24;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.1s;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-left: 130px;

  &:hover {
    background: #cc5803;
  }
`;

export const HistoryTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 12px;
`;

export const Th = styled.th`
  padding: 12px;
  background: #f8f9fa;
  text-align: center;
  font-weight: bold;
  color: #495057;
  border-bottom: 2px solid #e9ecef;
  font-size: 14px;
`;

export const Td = styled.td`
  padding: 12px;
  border-bottom: 1px solid #e9ecef;
  color: #495057;
  text-align: center;
  font-size: 14px;
`;

export const StatusBadge = styled.span`
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  
  ${props => {
    switch (props.status) {
      case 'pending':
        return `
          background-color: #e2e8f0;
          color: #64748b;
        `;
      case 'completed':
        return `
          background-color: #dcfce7;
          color: #16a34a;
        `;
      case 'non-pay':
        return `
          background-color: #fee2e2;
          color: #dc2626;
        `;
      case 'error':
        return `
          background-color: #fef2f2;
          color: #991b1b;
        `;
      default:
        return `
          background-color: #e2e8f0;
          color: #64748b;
        `;
    }
  }}
`;

export const ItemsContainer = styled.div`
  width: 100%;
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 4px;
  background: #f8f9fa;
  margin-top: 4px;
`;

export const ItemCard = styled.div`
  background: white;
  border-radius: 4px;
  padding: 6px 8px;
  margin-bottom: 4px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  transition: all 0.2s ease;
  font-size: 0.9em;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ItemInfo = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const ItemName = styled.span`
  font-weight: 500;
  color: #333;
  font-size: 13px;
`;

export const ItemDetails = styled.div`
  display: flex;
  gap: 4px;
  white-space: nowrap;
`;

export const DetailBadge = styled.span`
  background: #f1f3f5;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 12px;
  color: #495057;
`;

export const ModernProductItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin: 4px 0;
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 6px;
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: #f8f9fa;
  }
`;

export const ProductInfo = styled.div`
  flex: 1;
  margin-left: 8px;
  display: flex;
  align-items: center;
`;

export const ProductDetails = styled.div`
  display: flex;
  gap: 8px;
  margin-left: 12px;
`;

export const ModernTotalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  margin-left: 120px;
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
`;

export const TotalLabel = styled.span`
  font-size: 14px;
  color: #495057;
`;

export const TotalPrice = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #2563eb;
`;

export const InputContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;

    input {
        width: 100%;
        padding-right: 120px;
    }
`;

export const CustomerHistoryButton = styled.button`
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    padding: 4px 8px;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    white-space: nowrap;
    transition: background-color 0.1s;
    z-index: 1;

    &:hover {
        background-color: #45a049;
    }
`;

// * 페이지네이션 스타일 섹션
export const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    gap: 10px;
`;

export const PaginationButton = styled.button`
    padding: 6px 12px;
    border: 1px solid #ddd;
    background-color: white;
    cursor: pointer;
    border-radius: 4px;

    .material-design-icon {
        transform: scale(2.0);  // 아이콘 크기만 1.5배로 키움
    }

    &:disabled {
        background-color: #f5f5f5;
        cursor: not-allowed;
    }
    
    &:hover:not(:disabled) {
        background-color: #f5f5f5;
    }
`;

export const PaginationNumbers = styled.div`
    display: flex;
    gap: 5px;
`;

export const PaginationNumber = styled.button`
    padding: 8px 12px;
    border: 1px solid #ddd;
    background-color: white;
    cursor: pointer;
    border-radius: 4px;
    
    &.active {
        background-color: #fb8b24;
        color: white;
        border-color: #fb8b24;
    }
    
    &:hover:not(.active) {
        background-color: #f5f5f5;
    }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  padding-bottom: 20px;
  gap: 10px;
`;

export const SubmitButton = styled.button`
  padding: 10px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  background-color: #007bff;
  color: white;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #2563eb;
  }
`;

export const CancelButton = styled.button`
  padding: 10px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  background-color: #6b7280;
  color: white;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #4b5563;
  }
`;

export const RedSpan = styled.span`
  color: #dc2626;
  margin-right: 4px;
`;

export const MessageContainer = styled.div`
  margin-left: 120px;
  margin-bottom: 10px;
`;

export const MobileCheckMessage = styled.div`
  font-weight: bold;
  font-size: 14px;
  text-align: center;
  color: #cc5803;
`;

export const ErrorMessage = styled.div`
  font-weight: bold;
  font-size: 12px;
  text-align: center;
  color: #dc2626;
`;


// * 로딩 스피너 스타일 섹션
export const LoadingOverlay = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    padding: 60px 20px;
    background: #ffffff;
    border-radius: 8px;
    position: relative;
`;

export const LoadingSpinner = styled.div`
    width: 48px;
    height: 48px;
    border: 4px solid #e5e7eb;
    border-top-color: #007bff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin-bottom: 20px;
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;

export const SpinnerRing = styled.div`
    /* 더 이상 사용하지 않음 - 단일 스피너로 변경 */
    display: none;
`;

export const LoadingText = styled.div`
    font-size: 15px;
    font-weight: 400;
    color: #374151;
    letter-spacing: 0;
    line-height: 1.5;
`;